import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Department } from '../model/department';
import { HttpHelperService } from './httphelper.service';
import { DepartmentCareHomePair } from '../model/departmentCareHomePair';
import { EnsureExternalDepartmentRequest } from '../model/ensure-external-department-request';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserSessionService } from './user-session.service';

const API_URL = environment.apiUrl;

@Injectable()
export class DepartmentService {
	constructor(private http: HttpClient,
		private userSessionService: UserSessionService,
		protected httpHelperService: HttpHelperService) {
	}

	getById(id: string) {
		return this.http.get<Department>(`${API_URL}department/${id}`, this.httpHelperService.getHttpOptions());
	}

	get(active?: boolean) {
		const queryString = active ? `?active=${active}` : "";
		return this.http.get<Department[]>(`${API_URL}department${queryString}`, this.httpHelperService.getHttpOptions());
	}

	getForCarehome(carehomeId: string) {
		return this.http.get<Department[]>(`${API_URL}carehome/${carehomeId}/departments`, this.httpHelperService.getHttpOptions());
	}

	create(department: Department) {
		return this.http.post<Department>(`${API_URL}department`, department, this.httpHelperService.getHttpOptions());
	}

	update(department: Department, id: string) {
		return this.http.post<Department>(`${API_URL}department/${id}`, department, this.httpHelperService.getHttpOptions());
	}

	ensureExternal(externalId: string, source: string, name: string): Observable<Department[]> {
		return this.http.post<Department[]>(`${API_URL}department/ensure-external`, [{
			ExternalId: externalId,
			ExternalSource: source,
			Name: name
		}], this.httpHelperService.getHttpOptions())
			.pipe(
				map(res => {
					return res.body!;
				})
			);
	}

	ensureExternalBatch(requests: EnsureExternalDepartmentRequest[]): Observable<Department[]> {
		return this.http.post<Department[]>(`${API_URL}department/ensure-external`,
			requests,
			this.httpHelperService.getHttpOptions())
			.pipe(
				map(res => {
					return res.body!;
				})
			);
	}

	persistCurrentDepartmentIds(departmentIds: string[]) {
		this.userSessionService.setUserCarehomePreferences({ departmentIds });
	}

	getCurrentDepartmentIds(): string[] {
		const preferences = this.userSessionService.getUserCarehomePreferences();
		if (Array.isArray(preferences['departmentIds'])) {
			return preferences['departmentIds'];
		}

		// Backward compatibility with the old single-department preference format.
		if (preferences['departmentId']) {
			return [preferences['departmentId']];
		}

		return [];
	}

	deserialize(value: string) {
		try {
			return <DepartmentCareHomePair[]>JSON.parse(value);
		} catch (error) {
			return null;
		}
	}

	SetDepartmentIds(departmentIds: string[]) {
		const url = `${API_URL}PushSubscriptions/SetDepartmentIds`;
		return this.http.post(url, departmentIds || [], this.httpHelperService.getHttpOptions());
	}
}
